import { useNavigate } from 'react-router-dom';
import { BOTTOM_NAVI_V2 } from '../../data/define';
import FullHeightContainer from '../../component/common/FullHeightContainer';
import BottomNavigationV2 from '../../component/common/BottomNavigationV2';
import ProfileHeader from '../../component/my/ProfileHeader';
import Url from '../../data/url';
import KidsReport from '../../component/my/KidsReport';
import Informations from '../../component/my/Infomations';
import Divider from '../../component/common/Divider';
import TopHeaderWithPrev from '../../component/common/TopHeaderWithPrev';
import GotoHistory from '../../component/my/GotoHistory';

import { useTranslation } from '../../hook/useTranslation';

export default function MyPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title={t('my.title')} onClickPrev={() => navigate(Url.Home)} />
      <div className="pageInner">
        <ProfileHeader />
        <Divider />
        <KidsReport />
        <Divider />
        <GotoHistory />
        <Divider />
        <Informations />
      </div>
      <BottomNavigationV2 focusTab={BOTTOM_NAVI_V2.MY} />
    </FullHeightContainer>
  );
}
